//-------------- IMPORTAÇÕES --------------//
import { useEffect, useContext } from "react";
import { Loading } from "../../shared/components";
import { LoadingContext } from "../../shared/context/LoadingContext";
import { UsuariosContext } from "./context/UsuariosContext";
import { loadUsersService } from "./services";
import { Main } from "./components"



//-------------- EXPORTAÇÃO DO COMPONENTE USUARIOS --------------//
export default function Usuarios() {



  //-------------- CRIAÇÃO DE HOOKS --------------//
  const { users, setUsers } = useContext(UsuariosContext); // Estado que armazena a lista de Usuários
  const { status, setStatus } = useContext(UsuariosContext); // Estado que armazena o Filtro Status de Usuário (Ativos, Inativos ou Todos)
  const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de carregamento está aparecendo ou não (inicia aparecendo)



  //-------------- USE EFFECT DE INICIALIZAÇÃO --------------//
  useEffect(() => {
    handleLoadingUsers();
  }, []);



  //-------------- USE EFFECT QUE ATUALIZA OS USUÁRIOS A CADA MUDANÇA DE FILTRO --------------//
  useEffect(() => {
    handleLoadingUsers();
  }, [status])



  //-------------- FUNÇÃO ASSÍNCRONA CARREGAR USUÁRIOS --------------//
  // Responsável por requisitar os usuário à API
  async function handleLoadingUsers() {
    setIsLoading(true);
    const response = await loadUsersService(status);
    if (response) {
      setUsers(response.data);
    }
    setIsLoading(false);
  };



  //-------------- RETORNO CONDICIONAL DO COMPONENTE USUÁRIOS --------------//
return (
    <>
      {isLoading || users === null ? <Loading /> : <Main />}
    </>
  )
}